import Grid from '@mui/material/Grid';
import logo from '../images/logo-min.svg';
import CssBaseline from '@mui/material/CssBaseline';

const Error404 = () => (
    <Grid container sx={{textAlign: 'center'}}>
        <CssBaseline />
        <Grid item xs={12} class="img404" >
            <img src={logo} alt="dash"  />
        </Grid>
        <Grid item xs={12}>
            <h1>404 oopsie</h1>
            <a href="/">Return to Home</a>
        </Grid>
    </Grid>
)
export default Error404;